import loadFile from './FileLoader'

//Asynchronously load a JSON file served over HTTP(S) and parse it. onSuccess is called with the parsed JSON and the XMLHttpRequest, onFail is called with 'retrieve', 'timeout', or 'parse' and the XMLHttpRequest. Timeout is in ms, 0 for no timeout.
export default function loadJSON(url, onSuccess, onFail=(type)=>{console.error('JSON load failed', url, type)}, timeout=0, disableCaching=false) {
  loadFile(url, (text, request)=>{
    try {
      onSuccess(JSON.parse(text), request);
    }catch(e) {
      onFail('parse', request);
    }
  }, onFail, timeout, disableCaching);
}


// WEBPACK FOOTER //
// ./src/utils/JSONLoader.js